(function () {

  function parseJson(root, selector) {

    var el = (root || document).querySelector(selector);

    if (!el) return null;



    try {

      return JSON.parse(el.textContent);

    } catch (error) {

      return null;

    }

  }



  function normalizeValue(value) {

    return (value || '').toString().trim().toLowerCase();

  }



  function findVariantForOption(component, optionValue) {

    if (!component || !component.variants || !component.variants.length) return null;



    var target = normalizeValue(optionValue);

    if (!target) {

      return (

        component.variants.find(function (variant) {

          return variant.available !== false;

        }) || component.variants[0]

      );

    }



    return (

      component.variants.find(function (variant) {

        return normalizeValue(variant.title) === target;

      }) ||

      component.variants.find(function (variant) {

        return normalizeValue(variant.option1) === target;

      }) ||

      component.variants.find(function (variant) {

        var title = normalizeValue(variant.title);

        return title.indexOf(target) !== -1 || target.indexOf(title) !== -1;

      }) ||

      component.variants[0]

    );

  }



  function getProductSection() {

    return document.querySelector('[data-section-type="product"]');

  }



  function getProductForm() {

    var section = getProductSection();

    return section ? section.querySelector('.ProductForm') : document.querySelector('.ProductForm');

  }



  function getSelectedOptionsFromVariant(variant) {

    if (!variant) return [];

    return [variant.option1, variant.option2, variant.option3].filter(function (value) {

      return value != null && value !== '';

    });

  }



  function getSelectedOptionsFromForm() {

    var form = getProductForm();

    if (!form) return [];



    var values = [];

    var options = form.querySelectorAll('.ProductForm__Variants > .ProductForm__Option');



    options.forEach(function (optionEl) {

      var checked = optionEl.querySelector('input[name^="option-"]:checked');

      if (checked) {

        values.push(checked.value.trim());

        return;

      }



      var selectedValue = optionEl.querySelector('.ProductForm__SelectedValue');

      if (selectedValue) {

        values.push(selectedValue.textContent.trim());

      }

    });



    return values;

  }



  function getInitialSelectedOptions() {

    var productData = parseJson(document, '[data-product-json]');

    if (!productData || !productData.product || !productData.product.variants) return [];



    var selectedId = productData.selected_variant_id;

    var variant =

      productData.product.variants.find(function (item) {

        return item.id === selectedId;

      }) || productData.product.variants[0];



    return getSelectedOptionsFromVariant(variant);

  }



  function updateImageSlot(selector, index, src, alt) {

    document.querySelectorAll(selector + '="' + index + '"]').forEach(function (slot) {

      if (slot.tagName === 'IMG') {

        slot.src = src;

        slot.alt = alt;

        slot.removeAttribute('srcset');

      } else {

        slot.innerHTML =

          '<img class="BundleProductGallery__Image" data-bundle-gallery-slot="' +

          index +

          '" src="' +

          src +

          '" alt="' +

          alt.replace(/"/g, '&quot;') +

          '">';

      }

    });

  }



  function getBundleOptionNames() {
    var productData = parseJson(document, '[data-product-json]');
    if (!productData || !productData.product || !productData.product.options) return [];
    return productData.product.options;
  }

  function getComponentOptionIndex(component, optionNames) {
    if (!optionNames || !optionNames.length) return component.optionIndex || 0;

    var title = normalizeValue(component.title);
    var handle = normalizeValue((component.handle || '').replace(/-/g, ' '));

    for (var i = 0; i < optionNames.length; i += 1) {
      var optionName = normalizeValue(optionNames[i]);
      if (!optionName) continue;
      if (optionName === title || optionName.indexOf(title) !== -1 || title.indexOf(optionName) !== -1) {
        return i;
      }
      if (handle && (optionName.indexOf(handle) !== -1 || handle.indexOf(optionName) !== -1)) {
        return i;
      }
    }

    return typeof component.optionIndex === 'number' ? component.optionIndex : 0;
  }

  function initBundleGallery() {

    var data = parseJson(document, '[data-bundle-gallery-json]');

    if (!data || !data.components || !data.components.length) return;



    function renderGallery(selectedOptions) {

      var options = selectedOptions && selectedOptions.length ? selectedOptions : getSelectedOptionsFromForm();



      if (!options.length) {

        options = getInitialSelectedOptions();

      }



      data.components.forEach(function (component, index) {
        var optionIndex = getComponentOptionIndex(component, getBundleOptionNames());
        var optionValue = options[optionIndex] || component.defaultTitle;
        var variant = findVariantForOption(component, optionValue);
        if (!variant || !variant.image) return;

        var alt = component.title || '';
        updateImageSlot('[data-bundle-gallery-slot', index, variant.image, alt);
        updateImageSlot('[data-bundle-contents-slot', index, variant.image, alt);
      });

    }



    function scheduleRender(selectedOptions) {

      window.requestAnimationFrame(function () {

        renderGallery(selectedOptions);

      });

    }



    renderGallery();



    var section = getProductSection();

    if (section) {

      section.addEventListener('variant:changed', function (event) {

        var variant = event.detail && event.detail.variant;

        scheduleRender(getSelectedOptionsFromVariant(variant));

      });

    }



    document.addEventListener('variant:changed', function (event) {

      var variant = event.detail && event.detail.variant;

      scheduleRender(getSelectedOptionsFromVariant(variant));

    });



    document.addEventListener('change', function (event) {

      if (event.target && event.target.name && event.target.name.indexOf('option-') === 0) {

        scheduleRender();

      }

    });



    document.addEventListener('click', function (event) {

      if (

        event.target.closest('[data-action="select-value"]') ||

        event.target.closest('.VariantSelector__Item') ||

        event.target.closest('.VariantSelector__Choice') ||

        event.target.closest('.SizeSwatch__Radio') ||

        event.target.closest('.ColorSwatch__Radio')

      ) {

        setTimeout(function () {

          scheduleRender();

        }, 50);

      }

    });

  }



  function formatMoney(cents, format) {

    if (typeof cents !== 'number' || isNaN(cents)) return '';

    var value = (cents / 100).toFixed(2);

    if (!format) return '$' + value;



    return format

      .replace(/\{\{\s*amount\s*\}\}/g, value)

      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(cents / 100))

      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, value.replace('.', ','));

  }



  function initBundlePricing(root) {

    var data = parseJson(root, '[data-bundle-pricing-json]');

    if (!data) return;



    var separateEl = root.querySelector('[data-bundle-separate-total]');

    var badgeEl = root.querySelector('[data-bundle-savings-badge]');

    if (!separateEl || !badgeEl) return;



    function render(separateTotal) {

      var savings = separateTotal - data.bundlePrice;

      separateEl.textContent = formatMoney(separateTotal, data.moneyFormat);



      if (savings > 0) {

        var percent = Math.round((savings / separateTotal) * 100);

        badgeEl.textContent =

          'Save ' + formatMoney(savings, data.moneyFormat) + (percent > 0 ? ' (' + percent + '%)' : '');

        root.hidden = false;

      } else {

        root.hidden = true;

      }

    }



    render(data.separateTotal);



    document.addEventListener('variant:changed', function () {

      render(data.separateTotal);

    });

  }



  // Items mode: bundles whose variants carry custom.bundle_items ([{handle, sku, qty}]).
  // The gallery snippet prints every variant's resolved contents as [data-bundle-items-json];
  // on variant change we swap the gallery tiles, rebuild "What's included" and re-price the saving.
  function formatMoneyShort(cents, format) {
    return formatMoney(cents, format).replace(/\.00(?!\d)/, '');
  }

  function escapeHtml(value) {
    return (value == null ? '' : String(value)).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }

  function getSelectedVariantId() {
    var form = getProductForm();
    var input = form && form.querySelector('[name="id"]');
    return input ? String(input.value) : null;
  }

  function initBundleItems() {
    var data = parseJson(document, '[data-bundle-items-json]');
    if (!data || !data.variants) return;

    var productData = parseJson(document, '[data-product-json]');
    var product = (productData && productData.product) || {};
    var variants = product.variants || [];
    var pendingFocus = null;

    function variantById(id) {
      return variants.find(function (variant) {
        return String(variant.id) === String(id);
      });
    }

    function optionsOf(variant) {
      return variant.options || [variant.option1, variant.option2, variant.option3].filter(function (value) {
        return value != null;
      });
    }

    function optionValues(index) {
      var values = [];
      variants.forEach(function (variant) {
        var value = optionsOf(variant)[index];
        if (value != null && values.indexOf(value) === -1) values.push(value);
      });
      return values;
    }

    // The variant reached by stepping one option to its next (+1) or previous (-1) value, wrapping round.
    function neighbour(variant, index, step) {
      var values = optionValues(index);
      if (values.length < 2) return null;
      var current = optionsOf(variant);
      var wanted = values[(values.indexOf(current[index]) + step + values.length) % values.length];
      return (
        variants.find(function (candidate) {
          return optionsOf(candidate).every(function (value, i) {
            return i === index ? value === wanted : value === current[i];
          });
        }) || null
      );
    }

    function itemKey(item) {
      return item.url + '|' + (item.variantTitle || '');
    }

    function qtyOf(entry, key) {
      return entry.items.reduce(function (sum, item) {
        return sum + (itemKey(item) === key ? item.qty || 1 : 0);
      }, 0);
    }

    // How many units of a "What's included" line each option controls: stepping that option takes them away.
    function unitsByOption(variant, item) {
      var key = itemKey(item);
      var qty = item.qty || 1;
      return optionsOf(variant).map(function (value, index) {
        var units = 0;
        for (var step = -1; step <= 1; step += 2) {
          var other = neighbour(variant, index, step);
          var otherEntry = other && data.variants[String(other.id)];
          if (otherEntry) units = Math.max(units, qty - qtyOf(otherEntry, key));
        }
        return units;
      });
    }

    // One row per line, owned by the option that changes it. A line two options pick the same variant for
    // (2 x Wooden Arms, both Ice Blue) is stored as one component with qty 2; it splits into a row per option,
    // so each pick keeps its own label and arrows.
    function rowsFor(variant, entry) {
      var rows = [];
      entry.items.forEach(function (item) {
        var units = variant ? unitsByOption(variant, item) : [];
        var owners = [];
        units.forEach(function (count, index) {
          if (count > 0) owners.push(index);
        });
        var split = owners.length > 1 && owners.reduce(function (sum, index) {
          return sum + units[index];
        }, 0) === (item.qty || 1);
        if (split) {
          owners.forEach(function (index) {
            rows.push({ item: item, option: index, qty: units[index] });
          });
        } else {
          rows.push({ item: item, option: owners.length ? owners[0] : -1, qty: item.qty || 1 });
        }
      });
      return rows;
    }

    // Select through the theme's own option picker so the form, URL, price and buy button all follow.
    function switchOption(index, step) {
      var current = variantById(getSelectedVariantId());
      var target = current && neighbour(current, index, step);
      if (!target) return;
      var value = optionsOf(target)[index];
      var picker = Array.prototype.find.call(
        document.querySelectorAll('.Popover__Value[data-option-position="' + (index + 1) + '"]'),
        function (button) {
          return button.getAttribute('data-value') === value;
        }
      );
      if (picker) {
        picker.click();
      } else {
        window.location.search = '?variant=' + target.id;
      }
    }

    var CHEVRON_PREV =
      '<svg width="9" height="16" viewBox="0 0 9 16" aria-hidden="true" focusable="false"><path d="M7.5 1.5 1.5 8l6 6.5" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var CHEVRON_NEXT =
      '<svg width="9" height="16" viewBox="0 0 9 16" aria-hidden="true" focusable="false"><path d="M1.5 1.5 7.5 8l-6 6.5" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    function arrowsHtml(option) {
      var name = escapeHtml(String((product.options || [])[option] || 'option').toLowerCase());
      return (
        '<button type="button" class="BundleContents__Arrow BundleContents__Arrow--prev" data-bundle-switch="-1" data-option-index="' +
        option + '" aria-label="Previous ' + name + '">' + CHEVRON_PREV + '</button>' +
        '<button type="button" class="BundleContents__Arrow BundleContents__Arrow--next" data-bundle-switch="1" data-option-index="' +
        option + '" aria-label="Next ' + name + '">' + CHEVRON_NEXT + '</button>'
      );
    }

    // "Hoodie Size: Kids" for lines the shopper can change; the component's own variant name otherwise.
    function variantLineHtml(item, option, variant) {
      if (option > -1) {
        return (
          '<span class="BundleContents__Variant">' + escapeHtml((product.options || [])[option]) + ': ' +
          '<span class="BundleContents__VariantValue">' + escapeHtml(optionsOf(variant)[option]) + '</span></span>'
        );
      }
      return item.variantTitle ? '<span class="BundleContents__Variant">' + escapeHtml(item.variantTitle) + '</span>' : '';
    }

    function render(variantId) {
      var entry = variantId && data.variants[String(variantId)];
      if (!entry || !entry.items || !entry.items.length) return;

      var tiles = [];
      entry.items.forEach(function (item) {
        for (var n = 0; n < (item.qty || 1); n += 1) tiles.push(item);
      });
      tiles.forEach(function (item, index) {
        if (item.image) updateImageSlot('[data-bundle-gallery-slot', index, item.image, item.title || '');
        document.querySelectorAll('[data-bundle-gallery-slot="' + index + '"]').forEach(function (slot) {
          var figure = slot.closest('.BundleProductGallery__Item');
          var label = figure && figure.querySelector('.BundleProductGallery__Label');
          if (label) label.textContent = item.title || '';
        });
      });

      var variant = variantById(variantId);
      var hasSwitches = false;
      var listHtml = rowsFor(variant, entry).map(function (row) {
        var item = row.item;
        var option = row.option;
        if (option > -1) hasSwitches = true;
        return (
          '<li class="BundleContents__Item">' +
          '<a class="BundleContents__Link" href="' + escapeHtml(item.url) + '">' +
          (item.thumb
            ? '<span class="BundleContents__Media"><img class="BundleContents__Image" src="' + escapeHtml(item.thumb) +
              '" alt="' + escapeHtml(item.title) + '" width="72" height="72" loading="lazy"></span>'
            : '') +
          '<span class="BundleContents__Body"><span class="BundleContents__Title">' + escapeHtml(item.title) + '</span>' +
          variantLineHtml(item, option, variant) +
          (row.qty > 1 ? '<span class="BundleContents__Qty">Qty ' + row.qty + '</span>' : '') +
          '<span class="BundleContents__Price">' + formatMoneyShort(item.price, data.moneyFormat) + ' each</span></span></a>' +
          (option > -1 ? arrowsHtml(option) : '') +
          '</li>'
        );
      }).join('');

      // Keep keyboard focus on the arrow that was pressed. One step re-renders several times (variant:changed, the
      // option change, the picker click), so after the first rebuild restores focus, later rebuilds keep it on the
      // same arrow while it still has focus.
      var focusAfter = pendingFocus;
      var active = document.activeElement;
      var activeList = active && active.hasAttribute && active.hasAttribute('data-bundle-switch') && active.closest('[data-bundle-items-contents]');
      if (!focusAfter && activeList) {
        focusAfter = { list: activeList, option: active.getAttribute('data-option-index'), step: active.getAttribute('data-bundle-switch') };
      }

      document.querySelectorAll('[data-bundle-items-contents]').forEach(function (list) {
        list.innerHTML = listHtml;
        list.classList.toggle('BundleContents__List--switch', hasSwitches);
      });

      if (focusAfter) {
        var focusTarget = focusAfter.list.querySelector(
          '[data-option-index="' + focusAfter.option + '"][data-bundle-switch="' + focusAfter.step + '"]'
        );
        if (focusTarget) focusTarget.focus({ preventScroll: true });
        pendingFocus = null;
      }

      var savings = entry.separateTotal - entry.price;
      document.querySelectorAll('[data-bundle-pricing]').forEach(function (block) {
        var separateEl = block.querySelector('[data-bundle-separate-total]');
        var badgeEl = block.querySelector('[data-bundle-savings-badge]');
        if (savings > 0) {
          var percent = Math.floor((savings * 100) / entry.separateTotal);
          if (separateEl) separateEl.textContent = formatMoneyShort(entry.separateTotal, data.moneyFormat);
          if (badgeEl) badgeEl.textContent = 'Save ' + formatMoneyShort(savings, data.moneyFormat) + (percent > 0 ? ' (' + percent + '%)' : '');
          block.hidden = false;
        } else {
          block.hidden = true;
        }
      });
    }

    function schedule(variantId) {
      // A timeout rather than requestAnimationFrame, which never fires while the tab isn't painting.
      setTimeout(function () {
        render(variantId || getSelectedVariantId());
      }, 0);
    }

    document.addEventListener('variant:changed', function (event) {
      var variant = event.detail && event.detail.variant;
      schedule(variant && variant.id);
    });

    document.addEventListener('change', function (event) {
      var name = event.target && event.target.name;
      if (name && (name === 'id' || name.indexOf('option-') === 0)) {
        setTimeout(function () {
          schedule();
        }, 50);
      }
    });

    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-action="select-value"]') || event.target.closest('.VariantSelector__Choice')) {
        setTimeout(function () {
          schedule();
        }, 50);
      }
    });

    // Arrows on the "What's included" thumbnails step that item's option.
    document.addEventListener('click', function (event) {
      var arrow = event.target.closest('[data-bundle-switch]');
      if (!arrow) return;
      event.preventDefault();
      var option = Number(arrow.getAttribute('data-option-index'));
      var step = Number(arrow.getAttribute('data-bundle-switch'));
      pendingFocus = { list: arrow.closest('[data-bundle-items-contents]'), option: option, step: step };
      switchOption(option, step);
    });

    // The Liquid list has no arrows; rebuild it once so they appear.
    render(getSelectedVariantId());
  }

  document.addEventListener('DOMContentLoaded', function () {

    if (document.querySelector('[data-bundle-gallery-json]')) {

      initBundleGallery();

    }



    document.querySelectorAll('[data-bundle-pricing]').forEach(initBundlePricing);

    if (document.querySelector('[data-bundle-items-json]')) {
      initBundleItems();
    }

    // "Choose your ... below" under What's included: glide to the dropdowns rather than jump.
    document.addEventListener('click', function (event) {
      var link = event.target.closest('[data-bundle-options-link]');
      var target = link && document.getElementById('BundleOptions');
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });

  });

})();

